
import { isAuthenticated } from '@/core/services/auth-service'
import { request } from '@/store/case'
import { defineComponent } from 'vue'

export default defineComponent({
  setup() {
    return {
      request,
      isAuthenticated
    }
  }
})
